import { toJS } from "mobx";
import { useObserver } from "mobx-react";
import React, { useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { useStores } from "../../store";

const data = [
  { month: "Jan", count: 150 },
  { month: "Feb", count: 23 },
  { month: "mar", count: 80 },
  { month: "Apr", count: 100 },
  { month: "May", count: 50 },
  { month: "Jun", count: 120 },
  { month: "Jul", count: 20 },
  { month: "Aug", count: 50 },
  { month: "Sep", count: 24 },
  { month: "Oct", count: 130 },
  { month: "Nov", count: 150 },
  { month: "Dec", count: 23 },
];
export default function BarGraph(props) {
  const { RecuiterStore } = useStores();
  useEffect(() => {
    console.log(toJS(props.data));
  }, [props.data]);
  const updateMonthToShortForm = (data) => {
    return data.map((obj) => {
      return {
        ...obj,
        month: obj.month.substring(0, 3), // Update the month to the first 3 letters
      };
    });
  };
  return useObserver(() => (
    <>
      <div className=" flex items-center justify-center h-full">
        <div
          className="bg-white md:pb-10 lg:pb-10  rounded-lg  max-w-2xl md:w-full w-[93%] mx-auto h-[301px]"
          style={{ boxShadow: "rgb(229 229 229) 0px 0px 60px 5px" }}
        >
          {/* Title and Select */}
          <div className="flex justify-between items-center px-6 mt-5 mb-2">
            <h2 className="md:text-lg lg:text-lg text-sm gil-med md:ml-2 lg:ml-2 text-gray-800 whitespace-nowrap">
              Applicants Tracking
            </h2>
            <div className="relative">
              <select
                value={RecuiterStore.assessmentType}
                onChange={(event) => {
                  RecuiterStore.setAssessmentType(event.target.value);
                }}
                className="border border-gray-200 rounded-md md:mr-5  w-[110px] md:w-full lg:mr-2 0  py-1 px-2 text-gray-900   "
              >
                <option value="applicants">Applicants</option>
                <option value="jobposts">Job Posts</option>
                <option value="interviews">Interviews</option>
                <option value="resumes">Resumes</option>
              </select>
            </div>
          </div>
          {/* Chart */}
          <ResponsiveContainer
            width={window.innerWidth > 800 ? "94%" : "99%"}
            height={220}
          >
            <BarChart
              data={updateMonthToShortForm(props.data ?? data)}
              barSize={15}
              margin={{ top: 10, right: 25, left: 30, bottom: -8 }}
            >
              <CartesianGrid strokeDasharray="4 4" vertical={false} />
              <XAxis
                dataKey="month"
                tick={{ fontSize: 9 }}
                tickLine={false}
                axisLine={false}
              />
              <YAxis
                tick={{ fontSize: 9 }}
                tickLine={false}
                axisLine={false}
                width={20}
              />
              <Tooltip
                cursor={{ fill: "rgba(255, 140, 66, 0.2)" }}
                contentStyle={{ borderRadius: "4px", borderColor: "#FF8C42" }}
              />
              <Bar dataKey="count" fill="#FF8C42" radius={[10, 10, 10, 10]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  ));
}
